// i18n area 'common' — locale pt-BR (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da common.pt-PT.ts e sovrascrive SOLO le chiavi
// che il brasiliano scrive davvero in un altro modo: lessico (usuário,
// arquivo, tela, senha, registro, seção, configurações, salvar, console) e
// morfologia verbale (il progressivo 'está a fazer' → 'está fazendo').
// DA RIVEDERE DA MADRELINGUA: restano fuori le scelte a bassa confidenza
// (alojar/hospedar, eliminar/excluir, arranque/inicialização) e la posizione
// dei clitici, che una regola meccanica non sa spostare.
// Sidecar anti-stantie: ../meta/common.pt-BR.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './common'

export const ptBR: DeepPartial<typeof enUS> = {
  nav: {
    monitoring: 'Monitoramento',
    clusterSettings: 'Configurações globais',
    users: 'Usuários e grupos'
  },
  search: {
    actions: {
      clusterSettings: 'Configurações do cluster',
      consoleOf: 'Ir para o console de {name}'
    }
  },
  stub: {
    sectionSummary_vms: 'Máquinas virtuais e os seus templates — ciclo de vida, snapshots, migração e consoles.',
    sectionSummary_catalogs: 'A casa dos artefactos de arquivo do cluster: imagens ISO, templates CT e VM e arquivos OCI, organizados em catálogos.',
    sectionSummary_services: 'Servidores DHCP e DNS derivados do registro de rede.',
    sectionSummary_cluster: 'Nós, pertença e configurações de cluster.',
    containers: 'Os containers de sistema estão no roadmap — esta seção irá alojá-los.',
    monitoring: 'Os dashboards de contenção cluster-wide (cpu.ready, pressão PSI, alertas integrados) estão chegando — hoje as mesmas métricas vivem nos detalhes de cada VM.'
  },
  home: {
    welcome: 'Iniciou sessão com o usuário: {name}'
  },
  notes: {
    saveError: 'Não foi possível salvar as notas'
  }
}
